import { render, staticRenderFns } from "./ImageWithErrorFallback.vue?vue&type=template&id=5421f64d"
import script from "./ImageWithErrorFallback.vue?vue&type=script&lang=js"
export * from "./ImageWithErrorFallback.vue?vue&type=script&lang=js"
import style0 from "./ImageWithErrorFallback.vue?vue&type=style&index=0&id=5421f64d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports